import React from 'react';
import {TextIndent} from "@phosphor-icons/react";

const IconExpandMenu = (props) => (
    <TextIndent {...props}/>
);

export default IconExpandMenu;